import {BuildConfigurationInput} from '../../types'

import {DateTimeConfiguration} from './types'

export const buildDateTimeConfiguration = ({
  options
}: BuildConfigurationInput): DateTimeConfiguration => {
  const {
    dateExceptions: {publicHolidays = [], excludedDates = []},
    businessDays = [],
    businessHours
  } = options.workCalendar
  return {
    dateTime: {
      businessDays,
      businessHours,
      holidays: excludedDates.concat(publicHolidays.map((publicHoliday) => publicHoliday.date))
    }
  }
}
